import { FetchErrorName } from './types';

export class NetworkError extends Error {
  public name = FetchErrorName.NetworkError;
  public payload?: unknown;
  public endpoint?: string;
  public url?: string;

  public constructor(message: string, payload?: unknown, endpoint?: string, url?: string) {
    super(message);
    this.payload = payload;
    Object.setPrototypeOf(this, NetworkError.prototype);
    this.endpoint = endpoint;
    this.url = url;
  }
}
